export const selectUser  = (store) => store.authSlice.user
